<app-navbar />
<div class="mt-18">
  <router-outlet />
  <app-whatsapp-btn />
</div>
<app-footer />